import { useState } from "react";
import ExpertB2BDataService from "../../../services/ExpertB2B";
import { useNavigate } from "react-router-dom";
import { State } from "country-state-city";
import { Select, HStack, IconButton, useToast } from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import { Languages } from "../../../Config/Expert";
import { MultiSelect } from "react-multi-select-component";

export const AddB2BExpert = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const user = localStorage.getItem("logged_in_email");

  const [expertDetails, setExpertDetails] = useState<any>({
    full_name: "",
    role: "",
    email: "",
    phone_number: "",
    rating: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    expert_level: "",
    work_experience: "",
    profile_link: [],
    category: "",
    prior_manoshala_clients: [],
    manoshala_spoc: user || "",
    worked_with_manoshala: null,
  });

  // console.log(expertDetails);

  const [bankDetails, setBankDetails] = useState({
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  });

  const states = State.getStatesOfCountry("IN").map((state) => ({
    value: state.name,
    label: state.name,
  }));

  const [priceRange, setPriceRange] = useState<any>({
    minPrice: "",
    maxPrice: "",
  });

  const [expertLanguage, setExpertLanguage] = useState<any>([]);

  const [profileLinkInputs, setProfileLinkInputs] = useState("");

  const [manoshalaClientInput, setManoshalaClientInput] = useState({
    main_account: "",
    client_name: "",
  });

  const [isOthersSelected, setIsOthersSelected] = useState(false);

  const price_range =
    priceRange.minPrice && priceRange.maxPrice
      ? `${priceRange.minPrice}-${priceRange.maxPrice}`
      : "NA";

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  const fullName = expertDetails.full_name.trim();
  const role = expertDetails.role.trim();
  const email = expertDetails.email.trim();
  const phoneNumber = expertDetails.phone_number.trim();
console.log("fullName",fullName);
console.log("role",role);
console.log("email",email);
console.log("phoneNumber",phoneNumber);
  if (!fullName || !role || !email || !phoneNumber) {
    toast({
      title: "Mandatory fields missing",
      description:
        "Please fill Expert Name, Expertise, Email and Phone Number.",
      status: "error",
      duration: 4000,
      isClosable: true,
      position: "top",
    });

    return;
  }

  const language = expertLanguage.map(
    (el: { value: string }) => el.value,
  );

  const data = {
    ...expertDetails,
    full_name: fullName,
    role,
    email,
    phone_number: phoneNumber,
    language,
    price_range,
    bank_details: bankDetails,
  };

  ExpertB2BDataService.addB2BExpert(token, data)
    .then(() => {
      toast({
        title: "Expert added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      navigate("/expertsb2b");
    })
    .catch((error: Error) => {
      console.error(error);

      toast({
        title: "Unable to add expert",
        description: "Something went wrong. Please try again.",
        status: "error",
        duration: 4000,
        isClosable: true,
        position: "top-right",
      });
    });
};

  const handleChange = (e: any) => {
    let value = e.target.value;

    setExpertDetails({
      ...expertDetails,
      [e.target.name]: value,
    });
  };

  const handleBankDetailsChange = (e: any) => {
    let value = e.target.value;

    setBankDetails({
      ...bankDetails,
      [e.target.name]: value,
    });
  };

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - B2B Expert</div>
      <div className="p-5">
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h4 className="mb-3">Basic Info</h4>
            <form
              className="add_assesment_form"
              onSubmit={(e: any) => handleSubmit(e)}
            >
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="full_name">
                    Expert Name <span className="required-star">*</span>
                  </label>

                  <input
                    value={expertDetails.full_name}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="full_name"
                    name="full_name"
                    // required
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="role">
                    Expertise <span className="required-star">*</span>
                  </label>

                  <input
                    value={expertDetails.role}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="role"
                    name="role"
                    // required
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="email">
                    Email <span className="required-star">*</span>
                  </label>

                  <input
                    value={expertDetails.email}
                    onChange={handleChange}
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    // required
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="phone_number">
                    Phone Number <span className="required-star">*</span>
                  </label>

                  <input
                    value={expertDetails.phone_number}
                    onChange={handleChange}
                    type="tel"
                    className="form-control"
                    pattern="[0-9]{10}"
                    minLength={10}
                    maxLength={10}
                    title="Please enter a valid 10-digit phone number"
                    id="phone_number"
                    name="phone_number"
                    // required
                  />
                </div>

                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="expertLanguage">
                    Language
                  </label>
                  <MultiSelect
                    options={Languages}
                    labelledBy="Select languages"
                    value={expertLanguage}
                    onChange={setExpertLanguage}
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="work_experience">
                    Work Experience (in years)
                  </label>
                  <select
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                    value={expertDetails.work_experience}
                    id="work_experience"
                    name="work_experience"
                  >
                    <option value="">Select</option>
                    <option value="1-3">1-3</option>
                    <option value="3-5">3-5</option>
                    <option value="5-10">5-10</option>
                    <option value="10+">10+</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="expert_level">
                    Expert Level
                  </label>
                  <select
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                    value={expertDetails.expert_level}
                    id="expert_level"
                    name="expert_level"
                  >
                    <option value="">Select</option>
                    <option value="junior">Junior</option>
                    <option value="mid">Mid</option>
                    <option value="senior">Senior</option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="category">
                    Category
                  </label>
                  <select
                    onChange={(e) => handleChange(e)}
                    className="form-control"
                    value={expertDetails.category}
                    id="category"
                    name="category"
                  >
                    <option value="">Select</option>
                    <option value="mental">Mental</option>
                    <option value="physical">Physical</option>
                    <option value="nutrition">Nutrition</option>
                    <option value="health">Health</option>
                    <option value="enagagment">Enagagment</option>
                    <option value="professional_training">
                      Professional Training
                    </option>
                  </select>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="rating">
                    Rating
                  </label>
                  <HStack spacing={1} aria-label="Select Rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <IconButton
                        key={star}
                        icon={<StarIcon />}
                        aria-label={`Select ${star} star${star > 1 ? "s" : ""}`}
                        variant="ghost"
                        color={
                          star <= Number(expertDetails.rating)
                            ? "yellow.400"
                            : "gray.300"
                        }
                        onClick={() =>
                          handleChange({
                            target: { name: "rating", value: star.toString() },
                          })
                        }
                        isRound
                        size="md"
                      />
                    ))}
                  </HStack>
                </div>

                <div className="form-group col-md-6 mb-4">
  <label
    className="form-label"
    htmlFor="worked_with_manoshala"
  >
    Worked with Manoshala?
  </label>

  <select
    className="form-control"
    id="worked_with_manoshala"
    name="worked_with_manoshala"
    value={
      expertDetails.worked_with_manoshala === null
        ? ""
        : String(expertDetails.worked_with_manoshala)
    }
    onChange={(e) =>
      setExpertDetails({
        ...expertDetails,
        worked_with_manoshala:
          e.target.value === ""
            ? null
            : e.target.value === "true",
      })
    }
  >
    <option value="">Select</option>
    <option value="true">Yes</option>
    <option value="false">No</option>
  </select>
</div>

                <div className="form-group col-md-12 mb-4">
                  <label className="form-label">
                    Old Clients with Manoshala
                  </label>

                  <div className="row">
                    <div className="col-md-4">
                      <select
                        className="form-control"
                        value={
                          isOthersSelected
                            ? "Others"
                            : manoshalaClientInput.main_account
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (value === "Others") {
                            setIsOthersSelected(true);
                            setManoshalaClientInput({
                              ...manoshalaClientInput,
                              main_account: "",
                            });
                          } else {
                            setIsOthersSelected(false);
                            setManoshalaClientInput({
                              ...manoshalaClientInput,
                              main_account: value,
                            });
                          }
                        }}
                      >
                        <option value="">Select Main Account</option>
                        <option value="EC">EC</option>
                        <option value="PLN">PLN</option>
                        <option value="LPG">LPG</option>
                        <option value="Unison">Unison</option>
                        <option value="AGH">AGH</option>
                        <option value="Mbuddy">Mbuddy</option>
                        <option value="PazC">PazC</option>
                        <option value="NovaB">NovaB</option>
                        <option value="PrD">PrD</option>
                        <option value="GoDigit">GoDigit</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>

                    {isOthersSelected && (
                      <div className="col-md-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Main Account"
                          value={manoshalaClientInput.main_account}
                          onChange={(e) =>
                            setManoshalaClientInput({
                              ...manoshalaClientInput,
                              main_account: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}

                    <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Client Name/End Account"
                        value={manoshalaClientInput.client_name}
                        onChange={(e) =>
                          setManoshalaClientInput({
                            ...manoshalaClientInput,
                            client_name: e.target.value,
                          })
                        }
                      />
                    </div>

                    <div className="col-md-1 px-1">
                      <button
                        type="button"
                        className="btn btn-primary w-60"
                        onClick={() => {
                          setExpertDetails({
                            ...expertDetails,
                            prior_manoshala_clients: [
                              ...expertDetails.prior_manoshala_clients,
                              {
                                main_account:
                                  manoshalaClientInput.main_account.trim(),
                                client_name:
                                  manoshalaClientInput.client_name.trim(),
                              },
                            ],
                          });

                          setManoshalaClientInput({
                            main_account: "",
                            client_name: "",
                          });
                          setIsOthersSelected(false);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>

                {expertDetails.prior_manoshala_clients.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.prior_manoshala_clients.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          <strong>{item.main_account}</strong> —{" "}
                          {item.client_name}
                          <span
                            className="close-icon"
                            onClick={() => {
                              const updatedClients = [
                                ...expertDetails.prior_manoshala_clients,
                              ];
                              updatedClients.splice(index, 1);

                              setExpertDetails({
                                ...expertDetails,
                                prior_manoshala_clients: updatedClients,
                              });
                            }}
                          >
                            &#10006;
                          </span>
                        </li>
                      ),
                    )}
                  </ul>
                )}

                <div className="form-group col-md-12 mb-4">
                  <label className="form-label" htmlFor="profile_link">
                    Profile Link
                  </label>
                  <div className="input-group">
                    <input
                      value={profileLinkInputs}
                      onChange={(e) => setProfileLinkInputs(e.target.value)}
                      type="text"
                      className="form-control"
                      id="profile_link"
                      name="profile_link"
                    />
                    <button
                      className="btn btn-primary ml-2"
                      type="button"
                      onClick={() => {
                        const profile_link = [...expertDetails.profile_link];
                        profile_link.push(profileLinkInputs);
                        setExpertDetails({
                          ...expertDetails,
                          profile_link: profile_link,
                        });

                        setProfileLinkInputs("");
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                {expertDetails.profile_link.length > 0 && (
                  <ul className="added-data-list">
                    {expertDetails.profile_link.map(
                      (item: any, index: number) => (
                        <li key={index}>
                          {item}

                          <span
                            className="close-icon"
                            onClick={() => {
                              const profile_links = [
                                ...expertDetails.profile_link,
                              ];
                              profile_links.splice(index, 1);
                              setExpertDetails({
                                ...expertDetails,
                                profile_link: profile_links,
                              });
                            }}
                          >
                            &#10006;
                          </span>
                        </li>
                      ),
                    )}
                  </ul>
                )}

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="city">
                    City
                  </label>
                  <input
                    value={expertDetails.city}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="state">
                    State
                  </label>
                  <Select
                    id="state"
                    name="state"
                    value={expertDetails.state}
                    onChange={(e) => handleChange(e)}
                    placeholder="Select State"
                  >
                    {states.map((state) => (
                      <option key={state.value} value={state.value}>
                        {state.label}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="country">
                    Country
                  </label>
                  <input
                    value={expertDetails.country}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="country"
                    name="country"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="pincode">
                    Pincode
                  </label>
                  <input
                    value={expertDetails.pincode}
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="form-control"
                    id="pincode"
                    name="pincode"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="address">
                    Address
                  </label>

                  <textarea
                    value={expertDetails.address}
                    onChange={(e) => handleChange(e)}
                    id="address"
                    name="address"
                    rows={3}
                    cols={30}
                    className="form-control"
                    placeholder="Enter the address"
                  ></textarea>
                </div>
              </div>

              <div className="form-row ">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Price Range</h4>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="priceRange">
                    from
                  </label>
                  <input
                    value={priceRange.minPrice}
                    onChange={(e) =>
                      setPriceRange({
                        ...priceRange,
                        minPrice: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control"
                    id="priceRange"
                    name="priceRange"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="priceRange">
                    to
                  </label>
                  <input
                    value={priceRange.maxPrice}
                    onChange={(e) =>
                      setPriceRange({
                        ...priceRange,
                        maxPrice: e.target.value,
                      })
                    }
                    type="text"
                    className="form-control"
                    id="priceRange"
                    name="priceRange"
                  />
                </div>
              </div>

              <div className="form-row ">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Bank Details</h4>
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="account_holder_name">
                    Account Holder Name
                  </label>
                  <input
                    value={bankDetails.account_holder_name}
                    onChange={handleBankDetailsChange}
                    type="text"
                    className="form-control"
                    id="account_holder_name"
                    name="account_holder_name"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="account_number">
                    Account Number
                  </label>
                  <input
                    value={bankDetails.account_number}
                    onChange={handleBankDetailsChange}
                    type="text"
                    className="form-control"
                    id="account_number"
                    name="account_number"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="bank_name">
                    Bank Name
                  </label>
                  <input
                    value={bankDetails.bank_name}
                    onChange={handleBankDetailsChange}
                    type="text"
                    className="form-control"
                    id="bank_name"
                    name="bank_name"
                  />
                </div>

                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="ifsc_code">
                    IFSC Code
                  </label>
                  <input
                    value={bankDetails.ifsc_code}
                    onChange={handleBankDetailsChange}
                    type="text"
                    className="form-control"
                    id="ifsc_code"
                    name="ifsc_code"
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
